import {
    FLOOR_PLAN_LIST_REQUEST,
    FLOOR_PLAN_LIST_SUCCESS,
    FLOOR_PLAN_LIST_FAIL,
    FLOOR_PLAN_CREATE_REQUEST,
    FLOOR_PLAN_CREATE_SUCCESS,
    FLOOR_PLAN_CREATE_FAIL,
    FLOOR_PLAN_CREATE_RESET,
    FLOOR_PLAN_UPDATE_REQUEST,
    FLOOR_PLAN_UPDATE_SUCCESS,
    FLOOR_PLAN_UPDATE_FAIL,
    FLOOR_PLAN_UPDATE_RESET,
    FLOOR_PLAN_DELETE_REQUEST,
    FLOOR_PLAN_DELETE_SUCCESS,
    FLOOR_PLAN_DELETE_FAIL,
    FLOOR_PLAN_DELETE_RESET,
} from '../constants/floorPlanConstants';

export const floorPlanListReducer = (
    state = { loading: false, data: [], error: null },
    action
) => {
    switch (action.type) {
        case FLOOR_PLAN_LIST_REQUEST:
            return { ...state, loading: true, error: null };
        case FLOOR_PLAN_LIST_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };
        case FLOOR_PLAN_LIST_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export const floorPlanCreateReducer = (
    state = { loading: false, data: null, error: null },
    action
) => {
    switch (action.type) {
        case FLOOR_PLAN_CREATE_REQUEST:
            return { loading: true, data: null, error: null };
        case FLOOR_PLAN_CREATE_SUCCESS:
            return { loading: false, data: action.payload, error: null };
        case FLOOR_PLAN_CREATE_FAIL:
            return { loading: false, data: null, error: action.payload };
        case FLOOR_PLAN_CREATE_RESET:
            return { loading: false, data: null, error: null };
        default:
            return state;
    }
};

export const floorPlanUpdateReducer = (
    state = { loading: false, data: null, error: null },
    action
) => {
    switch (action.type) {
        case FLOOR_PLAN_UPDATE_REQUEST:
            return { loading: true, data: null, error: null };
        case FLOOR_PLAN_UPDATE_SUCCESS:
            return { loading: false, data: action.payload, error: null };
        case FLOOR_PLAN_UPDATE_FAIL:
            return { loading: false, data: null, error: action.payload };
        case FLOOR_PLAN_UPDATE_RESET:
            return { loading: false, data: null, error: null };
        default:
            return state;
    }
};

export const floorPlanDeleteReducer = (
    state = { loading: false, data: null, error: null },
    action
) => {
    switch (action.type) {
        case FLOOR_PLAN_DELETE_REQUEST:
            return { loading: true, data: null, error: null };
        case FLOOR_PLAN_DELETE_SUCCESS:
            return { loading: false, data: action.payload, error: null };
        case FLOOR_PLAN_DELETE_FAIL:
            return { loading: false, data: null, error: action.payload };
        case FLOOR_PLAN_DELETE_RESET:
            return { loading: false, data: null, error: null };
        default:
            return state;
    }
};


